import { render, staticRenderFns } from "./PanelLoading.vue?vue&type=template&id=44d0fbaa&lang=html&"
import script from "./PanelLoading.vue?vue&type=script&lang=js&"
export * from "./PanelLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports